__turbopack_context__.v({
  "className": "l2xBFa_className",
  "variable": "l2xBFa_variable",
});
